import script from "./WPeriodontalReportCreation.vue?vue&type=script&lang=ts&setup=true"
export * from "./WPeriodontalReportCreation.vue?vue&type=script&lang=ts&setup=true"

import "./WPeriodontalReportCreation.vue?vue&type=style&index=0&id=b1a7d6ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1a7d6ae"]])

export default __exports__